import React, { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import DocumentDialog from './DocumentDialog';
import { DOCUMENTS } from './Constants';

interface DocumentLinkProps {
  document: keyof typeof DOCUMENTS;
  className?: string;
  children: ReactNode;
  onOpenChange?: (isOpen: boolean) => void;
}

const DocumentLink = ({
  document,
  className,
  children,
  onOpenChange,
}: DocumentLinkProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isOpenRef = useRef(false);
  const onOpenChangeRef = useRef(onOpenChange);

  useEffect(() => {
    onOpenChangeRef.current = onOpenChange;
  }, [onOpenChange]);

  useEffect(() => {
    return () => {
      if (isOpenRef.current) {
        onOpenChangeRef.current?.(false);
      }
    };
  }, []);

  return (
    <>
      <a
        className={className}
        href={DOCUMENTS[document].path}
        aria-haspopup="dialog"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          event.currentTarget.focus();
          isOpenRef.current = true;
          setIsOpen(true);
          onOpenChange?.(true);
        }}
      >
        {children}
      </a>
      {isOpen && (
        <DocumentDialog
          document={document}
          onClose={() => {
            isOpenRef.current = false;
            setIsOpen(false);
            onOpenChange?.(false);
          }}
        />
      )}
    </>
  );
};

export default DocumentLink;
